import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import PageComponent from './components/pages/pageComponent';
import DonorPage from './components/pages/donor/donor';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import DonationManagementPage from './components/pages/donation-management/donation-management';
import DonationDetailsPage from './components/pages/donation-details/donation-details';

const ProtectedRoute = ({ redirectPath = '/', children }: any) => {
  // const userData = localStorage.getItem('access_token');
  // const location = useLocation();
  // if (!userData) {
  //   return <Navigate to={redirectPath} state={{ from: location }} replace />;
  // }

  return children;
};

const Dashboard = () => {
  return <Outlet />;
};

function App() {
  return (
    <Router>
      <div className="App">
        <div className="app-container">
          <Routes>
            <Route
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
              path="/"
              key="DashboardPage"
            >
              <Route path="/donor-portal/:id" element={<PageComponent component={DonorPage} title="" />} />
              <Route path="/donor-portal" element={<PageComponent component={DonationManagementPage} title="" />} />
              <Route path="/donor-portal/:token/donation/:id" element={<PageComponent component={DonationDetailsPage} title="" />} />
            </Route>
          </Routes>
        </div>
      </div>
    </Router>
  );
}

library.add(fas, far);
export default App;
